module.exports = __webpack_public_path__ + "static/logo-footer-88c6e54e38c6985196d0d7ff91800357.png";